import { useState, type ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

const NAV_KEY = "rh_nav_collapsed";

export function Layout({ title, children }: { title: string; children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(NAV_KEY) === "1";
    } catch {
      return false;
    }
  });

  function toggleNav() {
    setCollapsed((c) => {
      const next = !c;
      try {
        localStorage.setItem(NAV_KEY, next ? "1" : "0");
      } catch {
        /* localStorage unavailable — non-fatal */
      }
      return next;
    });
  }

  return (
    <div className={"app" + (collapsed ? " nav-collapsed" : "")}>
      <Sidebar />
      <div className="main">
        <Topbar onToggleNav={toggleNav} />
        <main className="content">
          <h1 className="page-title">{title}</h1>
          {children}
        </main>
      </div>
    </div>
  );
}
